import React, { Component } from 'react';

/* eslint-disable no-use-before-define */
import { connect } from 'react-redux';
import * as actions from '../../actions/messaging-actions';

import config from '../../../config';

class Polling extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.startConversationPoll = this.startConversationPoll.bind(this);
        this.stopConversationPoll = this.stopConversationPoll.bind(this);
        this.restartConversationPoll = this.restartConversationPoll.bind(this);
    }

    componentDidMount() {
        if (!this.timer && this.props.auth.user) {
            this.setState({
                pollingInterval: this.props.messaging.pollingInterval || config.messaging.pollingIntervalMax,
            });
            this.startConversationPoll();
        }
    }

    componentWillUnmount() {
        this.stopConversationPoll();
    }

    startConversationPoll() {
        this.timer = setInterval(() => {
            this.props.getConvs({ userId: this.props.auth.user.id, polling: true });
            if (this.state.pollingInterval !== this.props.messaging.pollingInterval) {
                this.restartConversationPoll();
            }
        }, this.state.pollingInterval || config.messaging.pollingIntervalMax || 30000);
    }

    stopConversationPoll() {
        clearInterval(this.timer);
        this.timer = null;
    }

    restartConversationPoll() {
        this.stopConversationPoll();
        this.setState({
            pollingInterval: this.props.messaging.pollingInterval,
        });
        this.startConversationPoll();
    }

    render() {
        return (
            <div />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getConvs: ({ userId, polling }) => {
            dispatch(actions.getConvs({ userId, polling }));
        },
    };
}

function mapStateToProps({ messaging, auth }) {
    return { messaging, auth };
}
export default connect(mapStateToProps, mapDispatchToProps)(Polling);
